const MeauxminyRemixesStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://soundcloud.com/eauxminy/oh-naur-maurminy-flip" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-Zqpe0RhhFjcG4yYJ-piWpBA-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>Yung Skrrt - Oh Naur</strong><br/>
                (Maurminy Flip)
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">Remix</p>
            <a href="https://soundcloud.com/eauxminy/status-effect-meauxminy-flip?in=eauxminy/sets/lost" target="_blank" rel="noopener noreferrer">    
              <img src="https://i1.sndcdn.com/artworks-uerFy38uAa9tHTTJ-Kh3V9Q-t500x500.jpg" width="100%" alt=""/><br/>
              <p class="gallery-text">
                <strong>ANJU Online! - Status Effect</strong><br/>
                (Meauxminy Flip)
              </p>
            </a>
          </div>

        </div>
      </>
    );
  };
  export default MeauxminyRemixesStatic;